// extracted by mini-css-extract-plugin
export default {"ToggleSwitch":"_2IgDTE__bQ","slider":"_2IfOm9qQ_4"};